// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box_tags--common.is-invalid .b-form-tags[data-v-296245ab] {\n  border: 1px solid #ff3d60 !important;\n}\n.box_tags--common .custom__tags[data-v-296245ab] {\n  font-size: 14.4px;\n}\n[data-v-296245ab] button.btn.b-form-tags-button.py-0.btn-outline-secondary {\n  width: 65px;\n}\n[data-v-296245ab] .disabled_cursor input#tags-validation {\n  cursor: not-allowed;\n}", ""]);
// Exports
module.exports = exports;
